<template>
    <div class="container" style="padding-top: 10px">
        <div class="el-card box-card is-always-shadow">
            <div class="el-card__header">
                <div class="clearfix">
                    <span>Resumen del pedido</span>
                </div>
            </div>
            <div class="el-card__body">
                <p class="lead">
                    <img
                        class="profile-user-img img-responsive img-circle"
                        v-bind:src="avatar"
                        alt="User profile picture"
                    />
                    {{ shop.name }}
                </p>
                <form
                    :model="form"
                    label-width="120px"
                    @submit.prevent="onSubmit"
                >
                    <div class="text-left">
                        <p class="lead">Datos de Personales</p>
                        <div class="table-responsive">
                            <table class="table table-striped">
                                <tr>
                                    <th>Cédula:</th>
                                    <td>
                                        <input
                                            class="form-control"
                                            v-validate="'required'"
                                            name="identification"
                                            type="text"
                                            v-model.trim="form.identification"
                                            autocomplete="off"
                                            required
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Balance:</th>
                                    <td>
                                        {{
                                            (this.shop.day_limit -
                                                this.dayTotal)
                                                | currency
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <th>Código de empleado:</th>
                                    <td>
                                        <input
                                            v-model="form.code"
                                            type="password"
                                            name="code"
                                            autocomplete="off"
                                            required="required"
                                            class="form-control"
                                            aria-required="true"
                                            aria-invalid="false"
                                        />
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <p class="lead">Datos de la Compra</p>
                        <div class="table-responsive">
                            <table class="table table-striped">
                                <tr>
                                    <th>Monto a Facturar:</th>
                                    <td>
                                        {{
                                            (this.form.amount / 1.18) | currency
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <th>Impuesto:</th>
                                    <td>
                                        {{
                                            (this.form.amount -
                                                this.form.amount / 1.18)
                                                | currency
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <th>Cargo total:</th>
                                    <td>
                                        {{
                                            (this.form.amount * 0.02) | currency
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <th>Total a facturar:</th>
                                    <td>
                                        {{
                                            (this.form.amount * 1.02) | currency
                                        }}
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <input type="hidden" name="" v-model="form.amount" />

                    <div class="text-right">
                        <el-button type="danger" @click="$emit('cancel')"
                            >Cancelar</el-button
                        >
                        <el-button
                            type="primary"
                            @click="onSubmit"
                            :disabled="!shop.id || !incomeAmount"
                        >
                            Confirmar Orden
                        </el-button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
export default {
    name: "pay-wall",
    components: {},
    data() {
        return {
            tokenInfo: {},
            shop: {},
            incomeAmount: null,
            minSplits: 1,
            dayTotal: 0,
            avatar: "https://via.placeholder.com/150",
            form: {
                identification: "",
                total_splits: 1,
                amount: "",
                shop_id: "",
                code: "",
                date: moment().format("YYYY-MM-DD"),
                employee_id: "",
                subtotal: 0,
                description: 0,
                total: 0,
                status: 0,
            },
            isLoading: false,
            labels: {
                identification: "Cedula",
                total_splits: "Cuotas",
                amount: "Monto",
                shop_id: "Codigo de tienda",
                code: "codigo de empleado",
                date: "fecha",
                employee_id: "Empleado",
                subtotal: "subtotal",
                total: "total",
            },
            employee: {
                profiles: {
                    first_name: "",
                    first_surname: "",
                    second_surname: "",
                },
            },
        };
    },
    async created() {
        this.getTokenInfo();
    },
    watch: {
        "form.identification": function (val) {
            if (this.form.identification.length == 11) {
                this.getUser();
                this.getCreditLimit();
            } else {
                this.setProfileNull();
            }
        },
    },
    methods: {
        setProfileNull() {
            this.employee.profiles.first_name = "";
            this.employee.profiles.first_surname = "";
            this.employee.profiles.second_surname = "";
        },
        getUser() {
            axios
                .get(
                    `${API_URL}/users?q=(identification:${this.form.identification})&relationships=profiles,employees`
                )
                .then(({ data }) => {
                    if (data.length >= 1) {
                        this.employee = data[0];
                        this.form.employee_id = this.employee.employees.id;
                        this.getDayTotal();
                    } else {
                        this.setProfileNull();
                    }
                });
        },
        getDayTotal() {
            const date = moment().format("YYYY-MM-DD");
            axios
                .get(
                    `${API_URL}/orders/employee-total/${this.form.employee_id}/${date}`
                )
                .then((res) => {
                    this.dayTotal = res.data.sum;
                });
        },
        async onSubmit() {
            if (!this.shop.id || !this.incomeAmount) {
                return;
            }

            const formData = Object.entries(this.form);

            if (
                formData.some((entry) => {
                    if (!entry[1] && entry[0] != "status") {
                        const label = this.labels[entry[0]] || entry[0];
                        this.$notify({
                            title: "Error",
                            message: `el campo: ${label} es requerido`,
                            type: "error",
                        });

                        return !entry[1];
                    }
                })
            ) {
                return;
            }
            axios
                .post(`${API_URL}/orders/pay-wall`, this.form)
                .then(({ data }) => {
                    this.onOrderSucess(this.form);
                })
                .catch((error) => {
                    this.$notify({
                        title: "Error",
                        message: error.data.status.message,
                        type: "error",
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        getTokenInfo() {
            axios
                .get(`${API_URL}/orders/token-info/${this.$route.query.token}`)
                .then((res) => {
                    this.tokenInfo = res.data;
                    this.form.amount = res.data.amount;
                    this.form.description = res.data.description;
                    this.form.total = this.form.amount;
                    this.form.subtotal = this.form.amount;
                    this.getShops(res.data.shop_id);
                })
                .catch((err) => {});
        },
        getShops(id) {
            axios
                .get(`${API_URL}/shops/${id}`)
                .then((res) => {
                    this.shop = res.data;
                    this.form.shop_id = this.shop.id;
                })
                .catch((err) => {});
        },

        getCreditLimit() {
            if (!this.form.identification) {
                return;
            }

            const amount = this.form.subtotal;
            axios
                .get(
                    `${API_URL}/employees/${this.form.identification}/limit_credit`
                )
                .then(({ data }) => {
                    if (data) {
                        this.incomeAmount = data.monthlyIncome * 1;
                        this.availableAmount = data.available_amount * 1;
                        this.form.employee_id = data.employee_id;
                        this.form.total_splits.minSplits = this.minSplits * 1;
                    }
                })
                .catch((e) => {});
        },

        onOrderSucess(order) {
            this.resetForm();
            this.$store.dispatch("setLastOrder", order);
            this.$router.push("order-success");
        },
    },
};
</script>
